const personalData = {
    name: "טליה כהן",
    title: "מפתחת פול סטאק",
    focus: "פיתוח צד שרת (Backend)",
    education: "בוגרת לימודי הנדסאי תוכנה מטעם מכון לב, כמו כן סיימתי קורס FS מתקדם מטעם Elevation",
    languages: ["JavaScript", "C#", "React", "Node.js", "MongoDB", "MySQL"],
    location: "תל אביב, ישראל",
    about: "בוגרת הנדסת תוכנה עם ניסיון מעשי בפיתוח מערכות פול סטאק, תוך שימוש ב-React, Node.js, Express, MySQL, MongoDB ו-C#. \n בעלת יכולת למידה עצמאית גבוהה, גישה יצירתית לפתרון בעיות ויכולת עבודה בצוות ."
};


export default personalData;



